import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';
import {
  POS_DESK_CATALOG_GUTTER,
  POS_DESK_CATALOG_RAIL_TO_GRID_GAP,
} from '../../application/posLayout.constants';

export const posCatalogHeaderStyleDefs = {
  header: {
    gap: spacing.sm,
    paddingBottom: spacing.md,
  },

  /** Mobile POS: menos aire vertical para no comerse la grilla. */
  headerMobileCompact: {
    gap: spacing.xs,
    paddingBottom: spacing.sm,
  },

  posQuickRailSlotMobile: {
    marginTop: 0,
    paddingTop: 6,
    paddingBottom: POS_DESK_CATALOG_RAIL_TO_GRID_GAP,
  },

  /** Fila de chips removibles bajo el buscador (antes de fulfillment / rail). */
  posActiveFiltersRow: {
    marginTop: 6,
    alignSelf: 'stretch',
  },

  /** PC desk: toolbar ya trae padding; sin gap/extra bottom del header mobile. */
  headerWide: {
    gap: 0,
    paddingBottom: 0,
    alignSelf: 'stretch' as const,
    width: '100%' as const,
  },

  /** Desk POS: header operativo sobre counter (proto `.desk`), no card paper flotante. */
  posDeskHeaderChromeSheet: {
    backgroundColor: ticketColors.counter,
    borderWidth: 0,
    borderRadius: 0,
  },

  /** Desk: mismo gutter que grilla/paginación (`POS_DESK_CATALOG_GUTTER`). */
  posDeskCatalogToolbarPad: {
    paddingHorizontal: POS_DESK_CATALOG_GUTTER,
    paddingTop: POS_DESK_CATALOG_GUTTER,
    paddingBottom: POS_DESK_CATALOG_GUTTER,
  },

  /** Toolbar desk cuando debajo va fulfillment/rail en columna catálogo. */
  posDeskCatalogToolbarPadSplit: {
    paddingHorizontal: POS_DESK_CATALOG_GUTTER,
    paddingTop: POS_DESK_CATALOG_GUTTER,
    paddingBottom: 0,
  },

  /** Rail / fulfillment dentro de TicketModuleHeader — separador del buscador. */
  posQuickRailSlot: {
    marginTop: 2,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    alignSelf: 'stretch',
  },

  posFulfillmentInHeader: {
    marginTop: 10,
    alignSelf: 'stretch',
    width: '100%',
  },

  posFulfillmentInHeaderMobile: {
    marginTop: 8,
  },

  /** Mobile: aire bajo Para llevar cuando no hay rail debajo. */
  posFulfillmentMobileRailToGridGap: {
    paddingBottom: POS_DESK_CATALOG_RAIL_TO_GRID_GAP,
  },

  /** Desk: modo de venta justo bajo el buscador (antes del rail). */
  posFulfillmentInHeaderDesk: {
    marginTop: 10,
  },

  /** Desk: fulfillment + rail en columna catálogo (no sobre el carrito). */
  posDeskCatalogChrome: {
    alignSelf: 'stretch',
    width: '100%',
    marginHorizontal: -POS_DESK_CATALOG_GUTTER,
    paddingHorizontal: POS_DESK_CATALOG_GUTTER,
    paddingTop: 6,
    paddingBottom: POS_DESK_CATALOG_RAIL_TO_GRID_GAP,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.counter,
  },

  posFulfillmentInHeaderDeskCatalog: {
    marginTop: 0,
  },

  posQuickRailSlotDeskCatalog: {
    marginTop: 0,
    paddingTop: 0,
    borderTopWidth: 0,
  },

  posQuickRailSlotAfterFulfillmentDesk: {
    marginTop: 6,
    paddingTop: 6,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },

  /** Rail bajo fulfillment en desk — hairline separa vistas de la grilla. */
  posQuickRailSlotAfterFulfillment: {
    marginTop: 8,
    paddingTop: 10,
  },

  headerWideCash: {
    paddingTop: 8,
    paddingBottom: 0,
  },

  posCashStatusLine: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    minHeight: 34,
    marginBottom: 10,
  },

  posQuickSaleLine: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
  },

  posCanvasTopPill: {
    minHeight: 34,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: spacing.md,
    paddingVertical: 7,
    alignItems: 'center',
    justifyContent: 'center',
  },

  posCanvasTopPillText: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },

  posCanvasQuickSalePill: {
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },

  posCanvasQuickSaleText: {
    color: ticketColors.ink,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },

  posQuickSaleSoloButton: {
    flex: 1,
    minHeight: 40,
  },

  posQuickSaleInlineChip: {
    flexShrink: 0,
    minHeight: 36,
    paddingHorizontal: spacing.sm,
  },

  statusPillClosedRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: spacing.xs,
  },

  statusPillClosedLink: {
    ...typography.caption,
    fontWeight: '700',
    color: ticketColors.brandInk,
    textDecorationLine: 'underline',
    fontFamily: ticketFonts.sans,
  },

  readOnlyBanner: {
    marginTop: spacing.xs,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
    padding: spacing.sm,
    backgroundColor: ticketColors.warnBg,
  },

  readOnlyText: {
    ...typography.caption,
    color: ticketColors.warn,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
  },

  caption: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  captionWarning: {
    color: ticketColors.warn,
  },

  section: {
    gap: spacing.md,
  },

  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    minHeight: 40,
  },

  sectionTitle: {
    ...typography.titleLg,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },

  categoryStripOuter: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: spacing.sm,
    alignSelf: 'stretch',
    minHeight: 40,
    maxHeight: 42,
    overflow: 'hidden',
  },

  categoryFilterIconText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },

  categoryStripList: {
    flex: 1,
    minWidth: 0,
    maxHeight: 42,
    overflow: 'hidden',
  },

  categoryStripContent: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: spacing.sm,
    paddingRight: spacing.xs,
    alignItems: 'center',
  },

  categoryChipCompact: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    borderRadius: 10,
    paddingVertical: 8,
    paddingHorizontal: 14,
    justifyContent: 'center',
    minHeight: 36,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    flexShrink: 0,
  },

  categoryChipColorDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    flexShrink: 0,
  },

  categoryChipCompactLabel: {
    ...typography.caption,
    fontWeight: '700',
    color: ticketColors.ink2,
    maxWidth: 120,
    fontFamily: ticketFonts.sans,
  },

  categoryChipCompactSelected: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },

  categoryChipCompactLabelSelected: {
    color: ticketColors.gold,
    fontWeight: '700',
  },

  categorySearchInlineChip: {
    flexDirection: 'row',
    gap: 6,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    flexShrink: 0,
  },

  lookupFeedback: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  posOfflineHint: {
    ...typography.caption,
    color: ticketColors.warn,
    fontWeight: '600',
    lineHeight: 16,
    fontFamily: ticketFonts.sans,
  },

  posWebSearchShortcutHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '600',
    marginTop: -4,
    fontFamily: ticketFonts.sans,
  },

  posCanvasCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: spacing.sm,
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },

  /** Desk: título del carrito anclado al borde inferior de la banda counter (paridad grilla). */
  posCanvasCardHeaderDeskChrome: {
    paddingTop: 0,
    paddingBottom: 8,
    paddingHorizontal: POS_DESK_CATALOG_GUTTER,
    backgroundColor: 'transparent',
    borderBottomWidth: 0,
  },

  /** Carrito en la fila del buscador (columna 340px). */
  posCanvasCardHeaderToolbarRow: {
    paddingVertical: 0,
    paddingHorizontal: POS_DESK_CATALOG_GUTTER,
    minHeight: 44,
    alignItems: 'center',
    borderBottomWidth: 0,
  },

  sectionTitleDesk: {
    fontSize: 15,
    fontWeight: '700',
    letterSpacing: -0.2,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
} as const;
